import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SamplesServices {
  constructor(private http: HttpClient) {}

  getSampleByUser(data: any) {
    return this.http
      .post<any>(`${environment.apiUrl}/request/SampleInfo/sample_by_user`, {
        user_identification: data.user_id
      })
      .pipe(
        catchError((res: HttpErrorResponse) => {
          if (res.status === HttpStatusCode.InternalServerError) {
            return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
          }
          if (res.status === HttpStatusCode.BadRequest) {
            return throwError(() => res.error)
          }
          if (res.status === HttpStatusCode.Unauthorized) {
            return throwError(() => 'El acceso a esta solicitud no estas permitido')
          }
          return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
        }),
        map((response: any) => {
          if (response.hasOwnProperty('payload')) {
            return response.payload
          }
          return response
        })
      )
  }

  updateSampleFileDownloaded(data) {
    return this.http.post<any>(`${environment.apiUrl}/Request/SampleInfo/sample_file_downloaded`, data).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }
        return response
      })
    )
  }

  getResultsPendingByUser(email: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/request/SampleInfo/number_results_pendings_downloaded`, {
        email
      })
      .pipe(
        catchError((res: HttpErrorResponse) => {
          if (res.status === HttpStatusCode.InternalServerError) {
            return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
          }
          if (res.status === HttpStatusCode.BadRequest) {
            return throwError(() => res.error)
          }
          if (res.status === HttpStatusCode.Unauthorized) {
            return throwError(() => 'El acceso a esta solicitud no estas permitido')
          }
          return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
        }),
        map((response: any) => {
          if (response.hasOwnProperty('payload')) {
            return response.payload
          }
          return response
        })
      )
  }
}
